import ActivityWebp from "@main/assets/images/appLogo/activity.webp";
import BrandMallWebp from "@main/assets/images/appLogo/brand-mall.webp";
import BusinessCardWebp from "@main/assets/images/appLogo/business-card.webp";
import BusinessWebp from "@main/assets/images/appLogo/business.webp";
import DashboardWebp from "@main/assets/images/appLogo/dashboard.webp";
import FinanceManageWebp from "@main/assets/images/appLogo/finance-manage.webp";
import MarketingToolsWebp from "@main/assets/images/appLogo/marketing-tools.webp";
import MemberManageWebp from "@main/assets/images/appLogo/member-manage.webp";
import OaWebp from "@main/assets/images/appLogo/oa.webp";
import PrivateDomainWebp from "@main/assets/images/appLogo/private-domain.webp";
import ResourceManageWebp from "@main/assets/images/appLogo/resource-manage.webp";
import SystemLogWebp from "@main/assets/images/appLogo/system-log.webp";
import WarehouseManageWebp from "@main/assets/images/appLogo/warehouse-manage.webp";
import WebsiteWebp from "@main/assets/images/appLogo/website.webp";
import type { RouteRecordRaw } from "vue-router";
import { activityManageRoutes } from "./activityManage";
import { brandMallRoutes } from "./brandMall";
import { brandWebsiteRoutes } from "./brandWebsite";
import { businessCenterRoutes } from "./businessCenter";
import { dataScreenRoutes } from "./dataScreen";
import { digitalCardRoutes } from "./digitalCard";
import { financeManageRoutes } from "./financeManage";
import { marketingToolsRoutes } from "./marketingTools";
import { memberManageRoutes } from "./memberManage";
import { oaOfficeRoutes } from "./oaOffice";
import { privateDomainRoutes } from "./privateDomain";
import { resourceManageRoutes } from "./resourceManage";
import { systemLogRoutes } from "./systemLog";
import { warehouseManageRoutes } from "./warehouseManage";

export const appRoutes: RouteRecordRaw[] = [
	{
		path: "/desktopCenter/businessCenter",
		name: "BusinessCenter",
		meta: {
			title: "商企中心",
			description: "商企中心提供全面的业务管理工具，帮助企业高效运营和发展",
			keepAlive: true,
			logo: BusinessWebp,
			appType: "BasicModule",
		},
		component: () => import("@main/layouts/AppMainPage/AppMainPage.vue"),
		redirect: businessCenterRoutes[0].path,
		children: [...businessCenterRoutes],
	},
	{
		path: "/desktopCenter/resourceManage",
		name: "ResourceManage",
		meta: {
			title: "资源管理",
			description: "资源管理提供高效的素材、模板和分类管理功能，助力企业优化资源利用和创作流程",
			keepAlive: true,
			logo: ResourceManageWebp,
			appType: "BasicModule",
		},
		component: () => import("@main/layouts/AppMainPage/AppMainPage.vue"),
		redirect: resourceManageRoutes[0].path,
		children: [...resourceManageRoutes],
	},
	{
		path: "/desktopCenter/digitalCard",
		name: "DigitalCard",
		meta: {
			title: "数字名片",
			description: "数字名片提供创新的名片管理和分享功能，帮助企业提升品牌形象和业务拓展",
			keepAlive: true,
			logo: BusinessCardWebp,
			appType: "MarketingCustomerAcquisition",
		},
		component: () => import("@main/layouts/AppMainPage/AppMainPage.vue"),
		redirect: digitalCardRoutes[0].path,
		children: [...digitalCardRoutes],
	},
	{
		path: "/desktopCenter/brandWebsite",
		name: "BrandWebsite",
		meta: {
			title: "品牌官网",
			description: "品牌官网提供专业的企业网站建设和管理解决方案，助力企业展示品牌形象和业务实力",
			keepAlive: true,
			logo: WebsiteWebp,
			appType: "MarketingCustomerAcquisition",
		},
		component: () => import("@main/layouts/AppMainPage/AppMainPage.vue"),
		redirect: brandWebsiteRoutes[0].path,
		children: [...brandWebsiteRoutes],
	},
	{
		path: "/desktopCenter/privateDomain",
		name: "PrivateDomain",
		meta: {
			title: "私域应用",
			description: "私域应用提供全面的企业私域流量管理和营销工具，助力企业提升客户关系和业务增长",
			keepAlive: true,
			logo: PrivateDomainWebp,
			appType: "MarketingCustomerAcquisition",
		},
		component: () => import("@main/layouts/AppMainPage/AppMainPage.vue"),
		redirect: privateDomainRoutes[0].path,
		children: [...privateDomainRoutes],
	},
	{
		path: "/desktopCenter/brandMall",
		name: "BrandMall",
		meta: {
			title: "品牌商城",
			description: "品牌商城提供丰富的商品和优质的购物体验，满足您的多样化需求",
			keepAlive: true,
			logo: BrandMallWebp,
			appType: "SalesManage",
		},
		component: () => import("@main/layouts/AppMainPage/AppMainPage.vue"),
		redirect: brandMallRoutes[0].path,
		children: [...brandMallRoutes],
	},
	{
		path: "/desktopCenter/oaOffice",
		name: "OaOffice",
		meta: {
			title: "OA办公",
			description: "OA办公提供全面的办公自动化解决方案，提升企业协作效率和办公体验",
			keepAlive: true,
			logo: OaWebp,
			appType: "OrganizationalManage",
		},
		component: () => import("@main/layouts/AppMainPage/AppMainPage.vue"),
		redirect: oaOfficeRoutes[0].path,
		children: [...oaOfficeRoutes],
	},
	{
		path: "/desktopCenter/warehouseManage",
		name: "WarehouseManageApp",
		meta: {
			title: "仓储管理",
			description: "仓储管理提供高效的库存和仓库管理工具，帮助企业优化供应链和物流流程",
			keepAlive: true,
			logo: WarehouseManageWebp,
			appType: "SalesManage",
		},
		component: () => import("@main/layouts/AppMainPage/AppMainPage.vue"),
		redirect: warehouseManageRoutes[0].path,
		children: [...warehouseManageRoutes],
	},
	{
		path: "/desktopCenter/memberManage",
		name: "MemberManageApp",
		meta: {
			title: "会员管理",
			description: "会员管理提供全面的会员信息和权益管理功能，帮助企业提升客户关系和业务增长",
			keepAlive: true,
			logo: MemberManageWebp,
			appType: "MemberOperations",
		},
		component: () => import("@main/layouts/AppMainPage/AppMainPage.vue"),
		redirect: memberManageRoutes[0].path,
		children: [...memberManageRoutes],
	},
	{
		path: "/desktopCenter/activityManage",
		name: "ActivityManageApp",
		meta: {
			title: "活动管理",
			description: "活动管理提供全面的活动信息和报名管理功能，帮助企业提升客户参与度和业务增长",
			keepAlive: true,
			logo: ActivityWebp,
			appType: "MemberOperations",
		},
		component: () => import("@main/layouts/AppMainPage/AppMainPage.vue"),
		redirect: activityManageRoutes[0].path,
		children: [...activityManageRoutes],
	},
	{
		path: "/desktopCenter/marketingTools",
		name: "MarketingToolsApp",
		meta: {
			title: "营销工具",
			description: "营销工具提供全面的营销活动和数据分析功能，帮助企业提升品牌影响力和业务增长",
			keepAlive: true,
			logo: MarketingToolsWebp,
			appType: "MemberOperations",
		},
		component: () => import("@main/layouts/AppMainPage/AppMainPage.vue"),
		redirect: marketingToolsRoutes[0].path,
		children: [...marketingToolsRoutes],
	},
	{
		path: "/desktopCenter/financeManage",
		name: "FinanceManageApp",
		meta: {
			title: "财务管理",
			description: "财务管理提供全面的财务信息和数据分析功能，帮助企业提升财务管理效率和业务增长",
			keepAlive: true,
			logo: FinanceManageWebp,
			appType: "OrganizationalManage",
		},
		component: () => import("@main/layouts/AppMainPage/AppMainPage.vue"),
		redirect: financeManageRoutes[0].path,
		children: [...financeManageRoutes],
	},
	{
		path: "/desktopCenter/dataScreen",
		name: "DataScreenApp",
		meta: {
			title: "数据大屏",
			description: "数据大屏提供全面的数据可视化和分析功能，帮助企业提升数据洞察力和业务决策能力",
			keepAlive: true,
			logo: DashboardWebp,
			appType: "OperationsMaintenance",
		},
		component: () => import("@main/layouts/AppMainPage/AppMainPage.vue"),
		redirect: dataScreenRoutes[0].path,
		children: [...dataScreenRoutes],
	},
	{
		path: "/desktopCenter/systemLog",
		name: "SystemLogApp",
		meta: {
			title: "系统日志",
			description: "系统日志提供全面的操作记录和数据分析功能，帮助企业提升系统管理效率和业务安全性",
			keepAlive: true,
			logo: SystemLogWebp,
			appType: "OperationsMaintenance",
		},
		component: () => import("@main/layouts/AppMainPage/AppMainPage.vue"),
		redirect: systemLogRoutes[0].path,
		children: [...systemLogRoutes],
	},
];
